module.exports = __webpack_public_path__ + "static/media/thats-amore.c94bd18e.jpg";